<template>
  <div :id="targetTodayIdName" class="module-item" :class="{ on : showMore, 'wait-unlock': !data.is_unlock }">
    <div
      class="head-box"
      :style="{ 'padding-top': data.module_type === 0 ? '22px' : '16px' }"
      @click="showMore = !showMore"
    >
      <div class="name" style="-webkit-box-orient: vertical;">{{ data.name }}</div>
      <div v-if="data.unlock_time" class="unlock-time" :class="{ today: isToday }">
        <span>{{ data.unlock_time | dateStr }}</span>
      </div>
      <div class="study-box" v-if="data.study_process_list.length && data.is_unlock">
        <span class="text">进度：</span>
        <div class="status-box">
          <div
            class="i-item"
            :class="{ finished: study.finished }"
            v-for="(study, sindex) in data.study_process_list"
            :key="sindex"
          >
            <i class="ic"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="body-box" v-show="showMore" v-cloak>
      <template v-for="(item, index) in data.details">
        <div class="detail" :key="index" :class="`detail-${item.object_type}`" @click.stop="onClick(item)">
          <span class="text" style="-webkit-box-orient: vertical;">{{ item.name }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { MODULE_DETAILS_OBJ_TYPE, LESSON_TYPE } from '@/common/js/config';
import { getStudyFinished } from '@/api/api';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isPaid: {
      type: Boolean,
      default: false
    },
    seriesId: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: Number,
      default: 0
    },
    campOpened: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    dateStr(time) {
      let res = time.replace(/-/g, '.');
      res = res.substr(0, 10);
      return res;
    }
  },
  computed: {
    isToday() {
      if (!this.data.unlock_time) {
        return false;
      }

      let unlockTime = this.data.unlock_time.replace(/-/g, '/');
      unlockTime = `${unlockTime.substr(0, 11)}00:00:00`;
      const today = `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()} 00:00:00`;
      return Math.abs(new Date(today).getTime() - new Date(unlockTime).getTime()) < 86400000;
    },
    targetTodayIdName() {
      if (this.isToday) {
        return 'today';
      }
      return '';
    }
  },
  data() {
    return {
      showMore: false
    };
  },
  mounted() {
    // 预习模块+未开营
    if (this.moduleType === 0 && !this.campOpened) {
      this.showMore = true;
    }
    if (this.isToday) {
      this.showMore = true;
    }

    setTimeout(() => {
      if (document.getElementById('today')) {
        const todayDom = document.getElementById('today');
        window.scrollTo(0, todayDom.offsetTop + todayDom.clientHeight);
      }
    }, 200);
  },
  methods: {
    onClick(data) {
      if (!this.data.is_unlock) {
        Toast('未解锁哦~');
        return;
      }

      if (data.object_type === MODULE_DETAILS_OBJ_TYPE.lesson) {
        if (data.lesson_type === LESSON_TYPE.video || data.lesson_type === LESSON_TYPE.voice) { // 视频 || 音频
          this.$router.push({
            name: 'camp-play',
            params: {
              lesson_id: data.object_id,
            },
            query: {
              cid: this.data.id,
              lt: data.lesson_type,
              sid: this.seriesId,
              t: +new Date()
            }
          });
        } else if (data.lesson_type === LESSON_TYPE.extUrl) { // 外链
          if (data.require_study) {
            getStudyFinished(data.id).then(() => {
              window.location.href = data.metas.ext_url;
            });
          } else {
            window.location.href = data.metas.ext_url;
          }
        }
      } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.clock) {
        this.$router.push({
          path: '/clock-in-theme',
          query: {
            id: data.id, // detail_id
          }
        });
      } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.exam) {
        console.log('考试');
        Toast('功能迭代中~');
      } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.live) {
        window.location.href = data.metas.yjlive_url;
      } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.material) {
        console.log('下载资料');
        Toast('功能迭代中~');
      } else if (data.object_type === MODULE_DETAILS_OBJ_TYPE.content) {
        console.log('去图文页面');
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.module-item {
  position relative
  width: 100%;
  background: #F6F7FA;
  border-radius: 4px;
  outline none
  &:not(:last-child) {
    margin-bottom 16px
  }
  &::after {
    content ''
    display block
    position absolute
    top 22px
    right 16px
    width 12px
    height 12px
    background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAHlBMVEUAAACqqqqZmZmZmZmZmZmZmZmZmZmZmZmYmJiZmZlv08dvAAAACXRSTlMAAw8ewMjS2t1lK8PQAAAASUlEQVQY02NgGBDAmKIAopjcBECcyiAQR3U6iMNgMRUoxRTZDFbH3AmUUp1hANEFlIJJgKXgEiApuARICiHBwGBejGyxAHU8AAAxXA1agMm2HAAAAABJRU5ErkJggg==') center no-repeat
    background-size cover
  }
  &.on {
    &::after {
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAHlBMVEUAAACqqqqZmZmZmZmZmZmZmZmZmZmZmZmYmJiZmZlv08dvAAAACXRSTlMAAw8ewMjS2t1lK8PQAAAASElEQVQY02NgoApgFEDimBcj2MydMwzgHIupkc0IiSBVuJTFVAUmmBRQgoEBJgWUYGCASjFWBoEo1ekguxhTFEAcJjcBhgEBABJTDVrfILerAAAAAElFTkSuQmCC') center no-repeat
      background-size cover
    }
  }
  &.wait-unlock {
    .head-box {
      .name {
        color: #999999;
      }
    }
    .body-box {
      .detail {
        padding-right 52px
        color: #999;
        &::after {
          content ''
          display block
          position absolute
          top 14px
          right 12px
          width 24px
          height 24px
          background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAV1BMVEUAAAD////U1NTq6urb29vc3Nze3t7Z2dnd3d3a2trb29va2trb29va2trb29va2tra2tra2tra2tra2tra2tre3t7k5OTn5+fw8PDx8fH6+vr9/f3///9BNV4PAAAAFHRSTlMAAQYMDiQvPUN9iJmarL/X6u3u8nBsIlcAAADCSURBVEjH7ZTJDoMgFEUdcMABFC9S8f3/d3bRNnWhhZcmrQvPipu8wwxJcvEr6lZPk27ryPJC4YkqYuqrEYMs87yUA8Yqov8RvXg0RY8xPIZCn77aaQ8VXC8G8U5iQGjlHeQ2SnQBQaPcxhI6IEzItzHHFBCAz/krIWsMdjFNtis0OKTZFcyxYA6mf8wJhNn7mSV4Is8SVqKVJSxEC0twRI4lWCLL21bvmedwW5iCc0zB2rPdpSiB/YDYT5T9CVz8kTs4BjS8S/VXPwAAAABJRU5ErkJggg==') center no-repeat
          background-size cover
        }
        .text {
          color #999
        }
      }
    }
  }
}
.head-box {
  position relative
  width 100%
  padding 16px 40px 16px 16px
  .name {
    width 100%
    font-size: 16px;
    font-weight: 500;
    color: $color-text;
    line-height: 24px;
    multi-line(2)
  }
  .unlock-time {
    margin-top 6px
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
    &.today {
      span {
        position relative
        display inline-block
        align-items center
        &::after {
          content '今'
          position absolute
          top -15px
          right -22px
          display inline-block
          padding: 4px;
          background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
          border-radius: 4px;
          font-size: 20px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 20px;
          text-align center
          transform: scale(0.5);
          transform-origin: 100% 100%;
        }
      }
    }
  }
  .study-box {
    position absolute
    right 16px
    bottom 16px
    display flex
    align-items center
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
    .status-box {
      display flex
      align-items center
      .i-item {
        display flex
        align-items center
        .ic {
          display inline-block
          width 12px
          height 12px
          background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUxpcdvb29zc3N7e3tra2tzc3P///9ra2unp6dra2tvb29ra2tra2jVN3D0AAAAMdFJOUwDbUzfzQgWaDIql5p76EP0AAAB9SURBVBjTY2DAB9i0RBwXJUA5imeAQAjC5jwDBhPAnDkQzkkQm+nMmeMWzTVnzigAOYlnTgcwMLDuOSMG5OicOQpSEHPmEJBcc6YAxGE/cwpIypwxAHGYzxwEkj5nGkAcjjNH0DkoylAMQDEaxVIU56A4FNULKJ5D9TZ2AAAlWk1vcCOxSAAAAABJRU5ErkJggg==') center no-repeat
          background-size 12px
        }
        &:not(:last-child)::after {
          content ''
          display block
          width: 9px;
          height: 2px;
          margin: auto 2px;
          background: #DADADA;
          border-radius: 1px;
        }
        &.finished {
          .ic {
            background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAYFBMVEUAAAD/k0X/kkD/lkX/lkX/mET/l0b/lkX/lkX/lkT/lkX/lkX/lkX/lkX/l0f/mEn/mk3/m07/nVH/o13/rGz/0rD/2b3/2r7/3cT/5ND/5tP/8uj/8un/9/H/+PT///8DPboDAAAADXRSTlMAGhxOa22atuTy+Pv9Q6NETwAAAKlJREFUKM910kkWgyAQBNASkdGKMWbSaLj/LbNQXwCllv+xaKobWCOkNs4ZLQXiVMpzi1fV32vLKLbevWmZpG2295mTbQ0AleUhtgKgMrw8nqQChM/8FZaOXkAe/HsnKaFPnRrm1GngSN6uudPBkd3yGTKngyE5hnlInQaaZD+FeUiceh23n8L8jp1y+2A/hcS92CvpxyVyqqjELi+xWHt5UeXVlo/h7Hx+j8IZb4aP4FgAAAAASUVORK5CYII=') center no-repeat
            background-size 12px
          }
          &:not(:last-child)::after {
            background: $color-theme;
          }
        }
      }
    }
  }
}
.body-box {
  position relative
  &::before {
    content ''
    display block
    position absolute
    top .5px
    left 0
    right 0
    width calc(100% - 32px)
    height .5px
    margin auto
    background #E7E7E7
  }
  .detail {
    position relative
    width 100%
    padding 16px 16px 16px 67px
    .text {
      display inline-block
      width 100%
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      multi-line(2)
    }
    &::before {
      content ''
      position: absolute;
      left: 16px;
      top: 16px;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      line-height: 20px;
    }
    &.detail-93 {
      &::before {
        content '直播 |'
      }
    }
    &.detail-131 {
      &::before {
        content '打卡 |'
      }
    }
    &.detail-132 {
      &::before {
        content '考试 |'
      }
    }
    &.detail-133 {
      &::before {
        content '资料 |'
      }
    }
    &.detail-134 {
      &::before {
        content '图文 |'
      }
    }
    &.detail-135 {
      &::before {
        content '课程 |'
      }
    }

  }
}
</style>
